<div class="box">
  <div class="bar">
    <div class="beam"></div>
    <p>{{loadingMessage}}</p>
  </div>
</div>
